<template>
    <div class="law-page">
        <div class="law-page__banner"></div>
        <div class="law-page__content">
            <div class="title">
                法律声明
            </div>
            <div class="word">
                <div class="word-item" v-for="(item, index) in itemList" :key="index">
                    <span class="word-item__index">{{ index + 1 }}、{{ item.title }}</span>
                    <div class="word-item__text">
                        <span class="text" style="white-space: pre-line;" v-for="(child, cIndex) in item.text" :key="cIndex">{{ child }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "lawVue",
    data() {
        return {
            itemList: [
                {
                    title: "规则及中协智能网站访问条件",
                    text: ["以下规则适用于所有访问本网站的用户或浏览者，中协智能保留随时修改这些规则的权利。访问本网站的权利由中协智能根据下列条款授予。 如果您不同意下列任何条款、请停止使用本网站。对于违反这些规则的行为，中协智能有权采取法律和公平的补救措施。"]
                },{
                    title: "不承诺责任声明",
                    text: ["本网站所载的材料和信息，包括但不限于文本、图片、数据、观点、建议、网页或链路，虽然中协智能力图在网站上提供准确的材料和信息， 但中协智能并不保证这些材料和内容的准确、完整、充分和可靠性，并且明确声明不对这些材料和内容的错误或遗漏承担责任，也不对这些材料和内容作出任何明 示或默示的、包括但不限于有关所有权担保、没有侵犯第三方权利、质量和没有计算机病毒的保证。",
                        "中协智能可以在没有任何通知或提示的情况下随时对本网站上的内容进行修改，为了得到最新版本的信息，请定时访问本网站。",
                        "中协智能在本网站上所提及的非中协智能产品或服务仅仅是为了提供相关信息，并不构成对这些产品、服务的认可或推荐。",
                        "中协智能并不就网站上提供的任何产品、服务或信息做出任何声明、保证或认可，所有销售的产品和服务应受本公司的销售合同和条款的约束。"]
                },{
                    title: "著作权说明",
                    text: ["本网站所载的所有材料或内容受版权法的保护，所有版权由中协智能拥有，但注明引用其他方的内容除外。未经中协智能或其他方事先书面许可， 任何人不得将本网站上的任何内容以任何方式进行复制、经销、翻印、播放、以超级链路连接或传送、以\"镜像法\"载入其他服务器上、存储于信息检索系统或者其他任 何商业目的的使用，但对于非商业目的的、个人使用的下载或打印（条件是不得修改，且须保留该材料中的版权说明或其他所有权的说明）除外。"]
                },{
                    title: "商标",
                    text: ["中协智能网站上使用和显示的所有商标、标志皆属中协智能所有，但注明属于其他方拥有的商标、标志、商号除外。中协智能网站所载的任何内容 不应被视作未经中协智能或其他方书面许可，以暗示、不反对或其他形式授予使用前述任何商标、标志的许可或权利。未经事先书面许可，任何人不得以任何方式使用中协智能商标、标记。"]
                },{
                    title: "提供的产品或服务",
                    text: ["由于互联网的国际性或无国界性，因此通过本网站所提供信息的亦具有国际性，所以不是所有的在本网站上所提到的产品或服务在您的国家或地区都提供，请联系当地的 销售代表或代理商了解在您的国家或地区所提供的产品或服务。"]
                },{
                    title: "第三方链接",
                    text: ["本网站可能保留有与第三方网站或网址的链接，访问这些链接将由用户自己作出决定，中协智能并不保证这些链接上所提供的任何信息、数据、观点、图片、陈述或建议的准确性、完 整性、充分性和可靠性。中协智能提供这些链接仅仅在于提供方便，并不表示中协智能对这些信息的认可和推荐，也不是用于宣传或广告目的。"]
                },{
                    title: "个人信息的保护",
                    text: ["中协智能充分尊重您的隐私权，并且不遗余力保护您的个人信息。通常情况下，您不需要提供任何个人信息就可以浏览中协智能的网站。为特定的目的，如果您以自愿填写的方式提供注 册或订阅电子信息所需的姓名、性别、证件种类及证件号、出生年月日、国家、电子邮件信箱、电话、联系地址和邮政编码、所希望提供的服务或喜好信息、客户代码以及其他类似的个人信息，则表示您已经了 解并接受您个人信息的用途，同意中协智能为实现该特定目的使用您的个人信息。",
                        "中协智能承诺在任何时候、任何情况下都不会出售您的个人信息，中协智能只会在法律允许的范围内使用根据本条款获得的信息。但中协智能可能会根据法律、政府部门的要求向这些部门提供 您某些个人信息；或在中协智能有理由认为有必要这样做来保护中协智能、客户或公众时，也可能在尽可能小的范围内公开某些个人信息，在您提供个人信息的时候应该已经预见并同意这种情况的发生。"]
                },{
                    title: "适用法律和管辖权",
                    text: ["通过访问本网站及使用通过本网站网址提供的设施和（或）服务, 即表示您同意该访问及该实施和/或服务的提供受中华人民共和国法律的约束，且您同意受中华人民共和国法院的管辖。"]
                },
            ]
        }
    }
}
</script>

<style scoped lang="less">
    .law-page {
        display: flex;
        flex-direction: column;
        background-color: #FFFFFF;
        padding-bottom: 90px;
        .law-page__banner {
            width: 100%;
            aspect-ratio: 3.2;
            background-image: url("../assets/law-banner.png");
            background-repeat: no-repeat;
            background-size: cover;
            margin-bottom: 60px;
        }
        .law-page__content {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            .title {
                width: max-content;
                font-size: 32px;
                line-height: 1;
                color: #184079;
                font-weight: bold;
                padding-bottom: 8px;
                border-bottom: 2px solid #ff6600;
                margin-bottom: 40px;
            }
            .word-item {
                display: flex;
                flex-direction: column;
                margin-bottom: 20px;
                .word-item__index {
                    color: #333333;
                    font-size: 16px;
                    font-weight: bold;
                    margin-bottom: 10px;
                }
                .word-item__text {
                    display: flex;
                    flex-direction: column;
                    color: #666666;
                    font-size: 14px;
                    text-indent: 20px;
                    .text {
                        margin-top: 8px;
                        &:nth-of-type(1) {
                            margin-top: 0;
                        }
                    }
                }
            }
        }
    }
</style>
